<template>
    <div class="animated fadeIn new_orders">
        <filters :scope="filtersScope">
        </filters>

        <operators-conversion-tabs/>
      <div class="container__table excel" style="overflow:hidden; width:100%">
        <div id="swipe" v-hammer:pan="onSwipe" style="display:flex;flex-wrap: nowrap; width: 100%;" :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}">
        <StatisticTable :headColumns="headColumns"
                        :footColumns="footColumns"
                        :rows="rows"
                        @isPopup="isPopup"
                        ref="statisticTable"
                        :title="`${$t('pages.new_orders')}`">
        </StatisticTable>
        </div>
      </div>
    </div>
</template>

<script>
    import OperatorsConversionTabs from './OperatorsConversionTabs'
    import Filters from '../../../../components/Filters'
    import StatisticTable from '../../../../components/StatisticTable'
    import API from '../../../../api/API'
    import {map} from 'lodash'
    import Helper from '../../../../api/Helper'
    import Storage from '../../../../api/Storage'
    import getSymbolFromCurrency from 'currency-symbol-map'
export default {
      components: {
        OperatorsConversionTabs,
        Filters,
        StatisticTable
      },
      data () {
        return {
          x: 0,
          filtersScope: {
            dateFilter: true,
            offerFilter: true,
            operatorFilter: true,
            byManualFilter: true
          },
          headColumns: [
            {label: this.$root.$t('statistic.operator'), field: 'operator'},
            {label: this.$root.$t('statistic.new_orders'), field: 'new_orders'},
            {label: this.$root.$t('statistic.approve'), field: 'approve', colspan: 2},
            {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid'},
            {label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2},
            {label: this.$root.$t('statistic.shipped'), field: 'shipped', colspan: 2},
            {label: this.$root.$t('statistic.buyoutSum'), field: 'buyoutSum', colspan: 2},
            {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
            {label: this.$root.$t('statistic.spam'), field: 'spam'},
            {label: this.$root.$t('statistic.holds'), field: 'holds'},
            {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2},
            {label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2},
            {label: this.$root.$t('statistic.call_duration'), field: 'call_duration'},
            {label: this.$root.$t('statistic.time_processing'), field: 'time_processing'},
            {label: this.$root.$t('statistic.time_out_calls'), field: 'time_out_calls'},
            {label: this.$root.$t('statistic.call_duration_approve'), field: 'call_duration_approve'},
            {label: this.$root.$t('statistic.call_duration_cancel'), field: 'call_duration_cancel'}
          ],
          rows: [],
          footColumns: {},
          operators: []
        }
      },
      mounted () {
        this.calculateRows()
        this.$root.$on('filters_load_new_data', () => {
          this.calculateRows()
        })
      },
      methods: {
        isPopup (cell) {
          let el = document.createElement('textarea')
          el.value = cell.value.trim()
          el.setAttribute('readonly', '')
          el.style.position = 'absolute'
          el.style.left = '-9999px'
          document.body.appendChild(el)
          el.select()
          document.execCommand('copy')
          document.body.removeChild(el)
          alert('Скопирован оператор ' + el.value)
        },
        onSwipe (e) {
          const offset = document.getElementById('swipe').offsetWidth
          const scroll = document.getElementById('swipe').scrollWidth
          const width = scroll - offset
          if (width > 0) {
            if (e.deltaX >= 0) {
              this.x += e.distance / 10
            } else {
              this.x -= e.distance / 10
            }
            if (this.x > 0) {
              this.x = 0
            }
            if (Math.abs(this.x) > width) {
              this.x = -width
            }
          }
        },
        async calculateRows () {
          this.rows = []
          this.footColumns = {}
          let oldArrCurrency = []
          let newArrCurrency = []
          this.operators = []
          await API.getOperators(Helper.getCountryList()).then(operators => {
            this.operators = operators.body
          })
          await API.getNewOrders().then(response => {
            map(response.data, d => {
              oldArrCurrency.push(d.local_currency.split(','))
              oldArrCurrency.forEach(array => {
                array.forEach(item => {
                  newArrCurrency.push(item)
                })
              })
            })
            let filterCurrency = newArrCurrency.filter((item, index) => {
              return newArrCurrency.indexOf(item) === index
            })
            let sumTotal = 0
            let sumApproved = 0
            let sumApprovedValid = 0
            let sumReturn = 0
            let sumCanceled = 0
            let sumShipped = 0
            let sumPaid = 0
            let sumSpam = 0
            let sumAverageBill = 0.0
            let sumAverageBillLocal = 0.0
            let sumAverageBuyback = 0.0
            let sumAverageBuybackLocal = 0.0
            let sumAverageCallDuration = 0
            let sumAverageSpentTime = 0
            let sumAverageWithoutCalls = 0
            let sumHold = 0
            let sumTotalCallApproved = 0.0
            let sumTotalCallCanceled = 0.0

            map(response.body, (d, index) => {
              this.rows.push({
                operator: {
                  value: `${index + 1}` + ' - ' + `${Helper.getOperatorLogin(this.operators, d.operator_id)} ${Storage.developMode ? `(${d.operator_id})` : ''}`,
                  popup: true
                },
                new_orders: {
                  value: d.total
                },
                approve: {
                  value: d.approved
                },
                approvePercent: {
                  value: d.total > 0 ? Helper.percents(d.total, d.approved) : '0%',
                  bgg: Helper.renderSingleGist(d.total, d.approved)
                },
                approvedFromValid: {
                  value: d.total > 0 ? Helper.percents((d.total - d.spam), d.approved) : '0%'
                },
                canceled: {
                  value: d.cancelled
                },
                canceledPercents: {
                  value: d.total > 0 ? Helper.percents(d.total, d.cancelled) : '0%',
                  bgg: Helper.renderGistPart(d.total, d.cancelled, true)
                },
                shipped: {
                  value: d.shipped
                },
                shippedPercents: {
                  value: d.total > 0 ? Helper.percents(d.total, d.shipped) : '0%',
                  bgg: Helper.renderGistPart(d.total, d.shipped, true)
                },
                buyoutSum: {
                  value: d.paid
                },
                buyoutSumPercents: {
                  value: d.total > 0 ? Helper.percents(d.approved, d.paid) : '0%',
                  bgg: Helper.renderGistPart(d.total, d.paid, true)
                },
                return: {
                  value: d.refunded
                },
                returnCountPercents: {
                  value: d.total > 0 ? Helper.percents(d.approved, d.refunded) : '0%',
                  bgg: Helper.renderGistPart(d.total, d.refunded, true)
                },
                spam: {
                  value: d.spam
                },
                holds: {
                  value: d.hold
                },
                averageBill: {
                  value: d.average_bill_usd > 0 ? '$ ' + (d.average_bill_usd).toFixed(2) : '$ 0.00',
                    // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_bill, nch, true)),
                  isCollspaned: true
                },
                averageBillLocal: {
                  value: d.local_currency.split(',').length === 1 ? `${d.average_bill_local} ${getSymbolFromCurrency(d.local_currency)}` : '-'
                    // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_bill, nch, false), false)
                },
                averageBuyback: {
                  value: d.average_buyout_usd > 0 ? '$ ' + (d.average_buyout_usd).toFixed(2) : '$ 0.00',
                    // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_buyout, nch, true)),
                  isCollspaned: true
                },
                averageBuybackLocal: {
                  value: d.local_currency.split(',').length === 1 ? `${d.average_buyout_local} ${getSymbolFromCurrency(d.local_currency)}` : '-'
                    // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_buyout, nch, false), false)
                },
                call_duration: {
                  value: Helper.hourAndMin(d.average_call_duration)
                },
                time_processing: {
                  value: Helper.hourAndMin(d.average_spent_time)
                },
                time_out_calls: {
                  value: Helper.hourAndMin(d.average_spent_time_without_calls)
                },
                call_duration_approve: {
                  value: d.approved > 0 ? Helper.hourAndMin(d.total_call_duration_approved / d.approved) : Helper.hourAndMin(d.total_call_duration_approved)
                },
                call_duration_cancel: {
                  value: d.cancelled > 0 ? Helper.hourAndMin(d.total_call_duration_canceled / d.cancelled) : Helper.hourAndMin(d.total_call_duration_canceled)
                }
              })
              if (d.total > 0) {
                sumTotal += parseInt(d.total)
              }
              if (d.approved > 0) {
                sumApproved += parseInt(d.approved)
                sumAverageBill += parseFloat(d.total_bill_usd)
                sumAverageBillLocal += parseFloat(d.total_bill_local)
                sumAverageBuyback += parseFloat(d.total_buyout_usd)
                sumAverageBuybackLocal += parseFloat(d.total_buyout_local)
                this.localCurrencySymbol = getSymbolFromCurrency(d.local_currency)
              }
              if (d.total && d.spam > 0) {
                sumApprovedValid += (parseFloat(d.total) - parseFloat(d.spam))
              }
              if (d.return > 0) {
                sumReturn += parseInt(d.refunded)
              }
              if (d.cancelled > 0) {
                sumCanceled += parseInt(d.cancelled)
              }
              if (d.shipped > 0) {
                sumShipped += parseInt(d.shipped)
              }
              if (d.paid > 0) {
                sumPaid += parseInt(d.paid)
              }
              if (d.spam > 0) {
                sumSpam += parseInt(d.spam)
              }
              if (d.total_call_duration > 0) {
                sumAverageCallDuration += d.total_call_duration
              }
              if (d.total_spent_time > 0) {
                sumAverageSpentTime += d.total_spent_time
              }
              if (d.total_spent_time_without_calls > 0) {
                sumAverageWithoutCalls += d.total_spent_time_without_calls
              }
              if (d.hold) {
                sumHold += d.hold
              }
              if (d.total_call_duration_approved > 0) {
                sumTotalCallApproved += d.total_call_duration_approved
              }
              if (d.total_call_duration_canceled > 0) {
                sumTotalCallCanceled += d.total_call_duration_canceled
              }
              if (d.refunded > 0) {
                sumReturn += d.refunded
              }
            })
            this.footColumns = {
              label: {
                value: this.$root.$t('statistic.in_total')
              },
              total: {
                value: `${sumTotal}`,
                graph: true
              },
              approve: {
                value: `${sumApproved}`
              },
              approvePercent: {
                value: Helper.percents(sumTotal, sumApproved)
              },
              approvedFromValid: {
                value: Helper.percents((sumTotal - sumSpam), sumApproved)
              },
              canceled: {
                value: `${sumCanceled}`,
                graph: true
              },
              canceledPercents: {
                value: Helper.percents(sumTotal, sumCanceled),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              shipped: {
                value: `${sumShipped}`
              },
              shippedPercents: {
                value: Helper.percents(sumApproved, sumShipped),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              paid: {
                value: `${sumPaid}`,
                graph: true
              },
              paidPercents: {
                value: Helper.percents(sumApproved, sumPaid),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              return: {
                value: `${sumReturn}`
              },
              returnPercents: {
                value: Helper.percents(sumApproved, sumReturn),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              spam: {
                value: `${sumSpam}`
              },
              holds: {
                value: sumHold
              },
              averageBill: {
                value: Helper.averageBillDayCount(sumAverageBill, sumApproved),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '$'
                }
              },
              averageBillLocal: {
                value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(sumAverageBillLocal, sumApproved, this.localCurrencySymbol) : '-',
                graph: filterCurrency.length === 1 ? {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: this.localCurrencySymbol
                } : false
              },
              averageBuyback: {
                value: Helper.averageBillDayCount(sumAverageBuyback, sumPaid),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '$'
                }
              },
              averageBuybackLocal: {
                value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(sumAverageBuybackLocal, sumPaid, this.localCurrencySymbol) : '-',
                graph: filterCurrency.length === 1 ? {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: this.localCurrencySymbol
                } : false
              },
              call_duration: {
                value: Helper.hourAndMin(Helper.averageFloat(sumAverageCallDuration, sumTotal))
              },
              time_processing: {
                value: Helper.hourAndMin(Helper.averageFloat(sumAverageSpentTime, sumTotal))
              },
              time_out_calls: {
                value: Helper.hourAndMin(Helper.averageFloat(sumAverageWithoutCalls, sumTotal))
              },
              call_duration_approve: {
                value: Helper.hourAndMin(Helper.averageFloat(sumTotalCallApproved, sumApproved))
              },
              call_duration_cancel: {
                value: Helper.hourAndMin(Helper.averageFloat(sumTotalCallCanceled, sumCanceled))
              }
            }
          })
        }
      }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// NewOrders.vue?5fb9271a